export function createDebugButton(label: string, onClick: () => void, style: Record<string, unknown> = {}) {
    const btnEl = document.createElement('div');
    btnEl.innerHTML = label;
    btnEl.classList.add('cr', 'function', 'property-name');
    btnEl.style.textAlign = 'center';
    btnEl.style.flexGrow = '1';
    btnEl.style.borderLeft = '0';
    btnEl.style.width = '30%';
    btnEl.style.userSelect = 'none';
    Object.assign(btnEl.style, style);

    btnEl.addEventListener('click', onClick);

    return btnEl;
}
